import { render } from "./GameRecommendationsFriendsPage.vue?vue&type=template&id=4f21cf77&scoped=true"
import script from "./GameRecommendationsFriendsPage.vue?vue&type=script&lang=js"
export * from "./GameRecommendationsFriendsPage.vue?vue&type=script&lang=js"

import "./GameRecommendationsFriendsPage.vue?vue&type=style&index=0&id=4f21cf77&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f21cf77"]])

export default __exports__